import Column from "@/Components/Grid/Column";
import React from "react";
import GraphSrcSetImage from "../GraphSrcSetImage/GraphSrcSetImage";

import { useEffect, useRef } from "react";
import { register } from "swiper/element/bundle";

register();

const AcfSlider = ({ slides }) => {
    const swiperRef = useRef(null);

    useEffect(() => {
        const swiperContainer = swiperRef.current;
        const params = {
            slidesPerView: 3,
            navigation: true,
            loop: true,
            centeredSlides: true,
            // autoplay: {
            //     delay: 2500,
            // },

            injectStyles: [
                `
            .swiper-button-next {
                rigth: 0;
            }

            .swiper-button-prev {
                left: 0;
            }

            .swiper {
                position: static;
            }

            :host {
                position: static;
            }

            ::slotted(swiper-slide) {
                display: flex;
                justify-content: center;
                align-content: center;
                height: 100%;
                padding: 0px 60px;
                transition: padding .3s ease-in-out;
                margin: auto;
            }
            ::slotted(swiper-slide.swiper-slide-active) {
                padding: 0px;
            }
        `,
            ],
        };

        Object.assign(swiperContainer, params);
        swiperContainer.initialize();
    }, []);
    return (
        <Column className="xl:my-c120 lg:my-20 md:my-15 my-10">
            <div className="relative">
                <swiper-container ref={swiperRef} init="false">
                    {slides.map((slide, index) => (
                        <React.Fragment key={index}>
                            <swiper-slide>
                                <div className="m-auto">
                                    <GraphSrcSetImage
                                        alt=""
                                        srcSet={slide.image.srcSet}
                                        className='w-full'
                                    />
                                </div>
                            </swiper-slide>
                        </React.Fragment>
                    ))}
                </swiper-container>
            </div>
        </Column>
    );
};

export default AcfSlider;
